var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"},on:{"enter":_vm.enter,"leave":_vm.leave,"after-enter":_vm.afterEnter}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }